<div class="sidebar-container">
  <div class="sidebar-header">
    <h3>تصنيف الخدمات</h3>
  </div>
  <ul class="sidebar-list">
    <li *ngFor="let service of services" [routerLink]="service.route" routerLinkActive="active" class="sidebar-item">
      <span class="service-title">{{ service.title }}</span>
      <div class="icon-box">
        <i [class]="service.icon"></i>
      </div>
    </li>
  </ul>
</div>